import { RefundDetails } from 'app/src/features/Shopping/Refund/components/RefundDetails'
import { RefundFunnel } from 'app/src/features/Shopping/Refund/components/RefundFunnel'
import { refundApi } from 'app/src/services/welfareportal'
import { ErrorPage, PageWidget } from 'app/src/shared/components'
import { ProgressSpinner } from 'primereact/progressspinner'
import { useTranslation } from 'react-i18next'
import { useParams } from 'react-router-dom'

export function Refund() {
  const params = useParams()
  const { t } = useTranslation('shopping', { keyPrefix: 'Refund' })

  const refundGetResponse = refundApi.useRefundRequestGet({
    pathParams: { refundId: params['id']! },
  })
  return (
    <PageWidget containerClassNamesOverrides='refundfunnel'>
      <>
        {refundGetResponse.isLoading || refundGetResponse.isFetching ? (
          <>
            <h1 className='welfareportal-titlecenter'>{t('loadingInProgressTitle')}</h1>
            <div className='mt-20 flex'>
              <div className='mx-auto'>
                <ProgressSpinner data-testid='loading-element' className='flex' />
                {t('loadingInProgressDescription') && (
                  <div className='mt-4' dangerouslySetInnerHTML={{ __html: t('loadingInProgressDescription') }} />
                )}
              </div>
            </div>
          </>
        ) : refundGetResponse.isError ? (
          <ErrorPage
            errorMessage={refundGetResponse.error.status == 404 ? t('refundNotFoundMessage') : t('loadingInProgressErrorMessage')}
          />
        ) : (
          refundGetResponse.data && (
            <>
              {refundGetResponse.data?.status?.value === 'DRAFT' ? (
                <RefundFunnel refund={refundGetResponse.data} />
              ) : (
                <RefundDetails refund={refundGetResponse.data} />
              )}
            </>
          )
        )}
      </>
    </PageWidget>
  )
}
